<template>
  <button v-if="isSupported" class="w-full" @click="handleClick">
    <div class="flex items-center p-4">
      <BaseLoadingIcon v-if="getUserGpsLocationMutation.isPending.value" class="mr-2 size-5" />
      <LocationTargetIcon v-else class="mr-2 size-5 text-terracota-dark" />
      <span class="text-sm text-left text-off-black">Use your current location</span>
    </div>
  </button>
</template>

<script setup lang="ts">
  import useUserGpsLocation from '@/api/mutations/userGpsLocation';
  import useGeoLocation from '@/composables/useGeoLocation';

  interface Emits {
    (e: 'onPosition', position: GeolocationPosition['coords']): void;
  }

  const emit = defineEmits<Emits>();

  const { isSupported } = useGeoLocation();

  const getUserGpsLocationMutation = useUserGpsLocation();

  const handleClick = () => {
    getUserGpsLocationMutation.mutate(undefined, {
      onSuccess: position => {
        emit('onPosition', position);
      },
    });
  };
</script>
